export default __webpack_public_path__ + "hero-next-2295-feb29c44a59801dc46bffdc64cb4bfbe.bundle.webp";